'use client';

import { CloudUpload } from '@mui/icons-material';
import { Button, Stack, TextField } from '@mui/material';
import { MarkdownRenderer } from '@prismo-io/design-system';
import { env } from '@prismo-io/env';
import { MuiFileInput } from 'mui-file-input';
import { useAction } from 'next-safe-action/hooks';
import {
  type FC,
  type HTMLAttributes,
  useCallback,
  useMemo,
  useState,
  useTransition,
} from 'react';
import { UploadFileAction } from './upload-file.action';

export type Action = {
  kind: 'UPLOAD_FILE';
  file: HTMLAttributes<HTMLInputElement> & { placeholder?: string };
  button: {
    text: string;
  };
};

type Tools = {
  id: string;
  logo?: string | null;
  name: string;
  function_url: string;
};

type Props = {
  tool: Tools;
  action: Action;
  debug?: boolean;
  onComplete?: () => void;
};

export const UploadFileForm: FC<Props> = (props) => {
  const { tool, action, onComplete = undefined, debug = false } = props;

  const [file, setFile] = useState<File | null>(null);

  const handleChange = useCallback((newFile: File | null) => {
    setFile(newFile);
  }, []);

  // Node 20
  // const { execute, status } = useAction(UploadFileAction, {
  //   onSuccess: () => {
  //     if (onComplete) {
  //       onComplete();
  //     }
  //   },
  // });

  // NODE 18
  const [isTransiting, setTransition] = useTransition();
  const status = useMemo(
    () => (isTransiting ? 'executing' : 'idle'),
    [isTransiting]
  );

  const execute = useCallback(
    (input: FormData) => {
      return setTransition(async () => {
        const res = await UploadFileAction(input);

        if (res.ok && onComplete) {
          onComplete();
        }
      });
    },
    [onComplete]
  );

  return (
    <Stack component="form" action={execute} gap={2}>
      <input
        name="toolId"
        type="text"
        value={tool.id}
        readOnly
        hidden={!debug && env.NEXT_PUBLIC_APP_ENV !== 'development'}
      />
      <input
        name="toolFunctionUrl"
        type="text"
        value={tool.function_url}
        readOnly
        hidden={!debug && env.NEXT_PUBLIC_APP_ENV !== 'development'}
      />
      <MuiFileInput
        name="file"
        value={file}
        onChange={handleChange}
        placeholder={action.file?.placeholder ?? 'Séléctionner un fichier'}
        InputProps={{
          inputProps: action.file,
        }}
        disabled={status === 'executing'}
      />
      <Button
        startIcon={<CloudUpload />}
        type="submit"
        disabled={!file || status === 'executing'}
      >
        {action.button.text}
      </Button>
    </Stack>
  );
};
